import React from 'react'
import { CircularProgress } from '@mui/material'
import cls from '../../../util/cls'

import styles from './button.module.css'

const Button = ({children, loading = false, variant, className, size = "big", ...rest}) => {
    const style = ({
        "outline": styles.outline,
        "primary": styles.primary,
        "error": styles.error,
        "fancy": styles.fancy,
    })[variant]

    const sizeCls = ({
        "big": styles.sizeBig,
        "normal": styles.sizeNormal,
    })[size]

    return (        
        <button {...rest} disabled={loading||rest?.disabled} className={cls(className, style, sizeCls)}>
            {loading===true?<CircularProgress size={20} /> :children}
        </button>        
    )
}

export default Button